module.exports = __webpack_public_path__ + "static/media/dyng_legend.db50607f.png";